import { motion } from "framer-motion"

const IconFullscreenExit = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M8 20v-4H4v-2h6v6H8Zm6 0v-6h6v2h-4v4h-2ZM4 10V8h4V4h2v6H4Zm10 0V4h2v4h4v2h-6Z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconFullscreenExit
